import React from 'react';
import Container from '../../../containers/integration/modules/moduleListContainer';

export default function () {
  return (
    <Container />
  );
}
